<template>
    <div class="field-checkboxes field-checkboxes--large">
        <ul class="field-checkboxes__list">
            <li v-for="item in items" v-bind:key="item.id" class="field-checkboxes__list-item">
                <input
                    :id="item.id"
                    type="checkbox"
                    :checked="isItemChecked(item.id)"
                    @change="checkItem(item.id, $event)"
                    class="field-checkboxes__input"
                />
                <label :for="item.id" class="field-checkboxes__label"
                    ><span class="field-checkboxes__pseudo-checkbox"></span
                    >{{ item.data.name }}</label
                >
            </li>
        </ul>
    </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import { toArray } from '@/helpers/utils';
import { ComplexFieldMixin } from '@/mixins/ComplexFieldMixin';

export default {
    data() {
        return {};
    },
    components: {},
    methods: {
        ...mapActions(['initOrUpdateList', 'setProp']),
        /* init */
        async init() {
            await this.initOrUpdateList({
                dataSource: this.dataSource,
                dataPreset: this.dataPreset,
                default: this.default
            });
        },
        /* validate */
        validate(val) {
            return !this.required || toArray(val).some((i) => i.visible);
        },
        /* custom setters */
        async checkItem(id, e) {
            await this.componentDifferChange();
            await this.setProp({
                source: this.dataSource + '.' + id + '.visible',
                value: e.target.checked
            });
            await this.componentDifferValidate();
        },
        /* custom getters */
        isItemChecked(id) {
            return toArray(this.getProp(this.dataSource)).some(
                (i) => i.id === id && i.visible === true
            );
        }
    },
    computed: {
        ...mapGetters(['getProp']),
        items() {
            return toArray(this.getProp(this.dataSource)).sort((a, b) => a.pos - b.pos);
        }
    },
    props: {
        dataSource: String,
        dataPreset: String,
        required: Boolean,
        default: String
    },
    mixins: [ComplexFieldMixin]
};
</script>
